<template>
  <v-app-bar dark fixed elevate-on-scroll color="#252525">
    <div
      @click="navigateHome()"
      :class="'d-flex align-center font-weight-medium btn-home' + (!smallScreen ? ' mr-15' : '')">
      <img
        style="margin-right: 10px"
        src="@/assets/images/logo_auth_yellow_24px.png"
        alt="logo_auth_yellow_512px" />
      Auth
    </div>

    <v-spacer></v-spacer>

    <v-fade-transition hide-on-leave v-if="!smallScreen">
      <v-btn-toggle v-model="activeRoute" group mandatory color="yellow" v-if="showAdminRoutes">
        <v-btn value="users" v-if="me.is_admin" class="btn-routes" text @click="navigateTo('users', $event)">Usuários</v-btn>
        <v-btn value="profiles" v-if="me.is_admin" class="btn-routes" text @click="navigateTo('profiles', $event)">Perfis</v-btn>
        <v-btn value="permissions" v-if="me.is_admin" class="btn-routes" text @click="navigateTo('permissions', $event)">
          Permissões
        </v-btn>
        <v-btn value="apps" v-if="me.is_admin" class="btn-routes" text @click="navigateTo('apps', $event)">Aplicações</v-btn>
        <v-btn value="logs" class="btn-routes" text @click="navigateTo('logs', $event)">Logs</v-btn>
      </v-btn-toggle>
    </v-fade-transition>

    <v-spacer></v-spacer>

    <v-toolbar-title v-if="me.is_admin || hasLogPermission" class="mr-3">
      <v-btn
        class="app-title"
        id="go-to-admin"
        v-if="showAdminBtn"
        text
        @click="showAdminSection()">
        {{ adminLabel }}
      </v-btn>
      <v-btn class="app-title" v-else text @click="navigateHome()"> apps </v-btn>
    </v-toolbar-title>

    <UserMenu :me="me" @logout="logout" @userProfile="dialogUser = true" @2fa="open2FaDialog" />

    <template v-slot:extension v-if="smallScreen && showAdminRoutes">
      <v-spacer></v-spacer>
      <v-sheet class="mx-auto" max-width="100%" color="#252525">
        <v-slide-group show-arrows v-model="activeRoute">
          <v-slide-item v-slot="{ active, toggle }">
            <v-btn
              text
              class="btn-routes mx-1"
              :input-value="active"
              :color="activeRoute == 'users' ? 'yellow' : ''"
              @click="
                navigateTo('users');
                toggle;
                activeRoute = 'users';
              ">
              Usuários
            </v-btn>
          </v-slide-item>
          <v-slide-item v-slot="{ active, toggle }">
            <v-btn
              text
              class="btn-routes mx-1"
              :input-value="active"
              :color="activeRoute == 'profiles' ? 'yellow' : ''"
              @click="
                navigateTo('profiles');
                toggle;
                activeRoute = 'profiles';
              ">
              Perfis
            </v-btn>
          </v-slide-item>
          <v-slide-item v-slot="{ active, toggle }">
            <v-btn
              text
              class="btn-routes mx-1"
              :input-value="active"
              :color="activeRoute == 'permissions' ? 'yellow' : ''"
              @click="
                navigateTo('permissions');
                toggle;
                activeRoute = 'permissions';
              ">
              Permissões
            </v-btn>
          </v-slide-item>
          <v-slide-item v-slot="{ active, toggle }">
            <v-btn
              text
              class="btn-routes mx-1"
              :input-value="active"
              :color="activeRoute == 'apps' ? 'yellow' : ''"
              @click="
                navigateTo('apps');
                toggle;
                activeRoute = 'apps';
              ">
              Aplicações
            </v-btn>
          </v-slide-item>
          <v-slide-item v-slot="{ active, toggle }">
            <v-btn
              text
              class="btn-routes mx-1"
              :input-value="active"
              :color="activeRoute == 'logs' ? 'yellow' : ''"
              @click="
                navigateTo('logs');
                toggle;
                activeRoute = 'logs';
              ">
              Logs
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
      <v-spacer></v-spacer>
    </template>

    <UserProfile
      @snackbar="$emit('snackbar', $event)"
      :me="me"
      @close="closeDialogUser"
      @me-updated="handleMeUpdated"
      :dialog="dialogUser" />

    <Activate2Fa
      :me="me"
      :dialog="twoFactorDialog"
      :is-mandatory="isTwoFaMandatory"
      @snackbar="$emit('snackbar', $event)"
      @close="HandleClose2FA"
      @success="handle2FaSuccess"
    />
  </v-app-bar>
</template>
<script lang="ts">
import { mapActions, mapGetters } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";

import { sendLogout as logSendLogout } from "@/services/logs";
import { toLogin } from "@/utils/redirects";
import { verifyDueDate } from "@/utils/date";

import UserProfile from "./dialogs/UserProfile.vue";
import Activate2Fa from "./dialogs/Activate2Fa.vue";
import UserMenu from "./UserMenu.vue";

@Component({
  components: {
    UserProfile,
    UserMenu,
    Activate2Fa,
  },
  computed: {
    ...mapGetters("meState", {
      me: "me",
    }),
  },
  methods: {
    ...mapActions("meState", ["fetchMe", "setMe"]),
  },
})
export default class Header extends Vue {
  $refs!: any;
  me!: any;
  fetchMe!: () => Promise<void>;
  setMe!: (payload: any) => void;
  actionsSetMe!: (payload: any) => void;

  showAdminBtn = true;
  showAdminRoutes = false;
  twoFactorDialog = false;
  dialogUser = false;
  activeRoute: any = 'users';
  isExpired: any = {
    expired: false,
  };


  get isTwoFaMandatory(): boolean {
      // 1. Verificação Estrita: Se o usuário não tiver ID carregado,
      // significa que o Vuex ainda está iniciando. Retorna false para não piscar.
      if (!this.me || !this.me.id) return false;

      // 2. Verifica se 2FA está ativo
      const _2faAtivo = this.me._2fa === "TOTP" || this.me._2fa === true;

      // 3. Verifica se tem a chave
      const temChave = (this.me.totp_key && this.me.totp_key !== "") ||
                       (this.me.has_totp_key === true);

      // Retorna true APENAS se estiver ativo E sem chave
      return !!(_2faAtivo && !temChave);
  }

  @Watch('me', { immediate: true, deep: true })
    onMeChanged(newVal: any) {
      // Se não tiver ID (dados incompletos), ignora
      if (!newVal || !newVal.id) return;

      if (this.isTwoFaMandatory) {
        this.twoFactorDialog = true;
      }
      else {
        // Se não é obrigatório, mas o modal está aberto, fecha.
        if (this.twoFactorDialog) {
          this.twoFactorDialog = false;
        }
      }

      this.syncHeaderRouteState();
    }

  @Watch("$route.path", { immediate: true })
  onRoutePathChanged(): void {
    this.syncHeaderRouteState();
  }

  get smallScreen(): boolean {
    if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
      return true;
    }
    return false;
  }

  get hasLogPermission(): boolean {
  if (!this.me || !this.me.roles) return false;

  return this.me.roles.some((r: any) => r.name === 'auth_logs');
  }

  get adminLabel(): string {
    if (this.me.is_admin) return "ADMIN";

    if (this.hasLogPermission) return 'Logs';

    return '';
  }

  async created(): Promise<void> {
    try {
      await this.fetchMe();
    } catch (error) {
      console.error(error);
      this.$emit("snackbar", {
        message: "Erro ao carregar as informaçẽos do usuário!",
      });
    }

    if (this.isTwoFaMandatory) {
      this.twoFactorDialog = true;
      this.$emit("snackbar", {
        left: true,
        multiLine: true,
        color: "red",
        textStyle: "font-weight: 600;",
        transition: "scroll-x-reverse-transition",
        message:
          "<i class='v-icon notranslate mr-2 mdi mdi-alert-circle-outline theme--dark'></i>Ative o 2FA",
        btn: {
          color: "white",
        },
      });
    }

    this.isExpired = verifyDueDate(this.me.password_due_date);
    if (this.isExpired.expired) {
      let expireTomorrow = this.isExpired.expire_in == 1;
      this.$emit("snackbar", {
        top: true,
        multiLine: true,
        color: expireTomorrow ? "red" : "yellow",
        textStyle: "font-weight: 600;" + (expireTomorrow ? "color: white;" : "color: black;"),
        transition: "scroll-x-reverse-transition",
        timeout: 30000,
        message:
          expireTomorrow
            ? `<i class='v-icon notranslate mr-2 mdi mdi-alert-circle-outline theme--dark'></i>Sua senha vai expirar amanhã!`
            : `<i class='v-icon notranslate mr-2 mdi mdi-alert-circle-outline' style='color: black;'></i>Sua senha vai expirar em ${this.isExpired.expire_in} dias`,
        btn: {
          color: expireTomorrow ? "white" : "black",
        },
      });
    }

    this.syncHeaderRouteState();
  }

  syncHeaderRouteState(): void {
    const isAdminRoute = this.$route.path.startsWith("/admin/");

    if (isAdminRoute && (this.me?.is_admin || this.hasLogPermission)) {
      this.showAdminRoutes = true;
      this.showAdminBtn = false;
    }

    switch (this.$route.name) {
      case "users":
        this.activeRoute = "users";
        break;
      case "profiles":
        this.activeRoute = "profiles";
        break;
      case "permissions":
        this.activeRoute = "permissions";
        break;
      case "apps":
        this.activeRoute = "apps";
        break;
      case "logs":
        this.activeRoute = "logs";
        break;
      default:
        this.activeRoute = this.me?.is_admin ? "users" : "logs";
        break;
    }
  }

  HandleClose2FA(): void {
    if (this.isTwoFaMandatory) {
      this.$emit("snackbar", { message: "A configuração do 2FA é obrigatória.", color: "warning" });
      return;
    }
    this.twoFactorDialog = false;
  }

  handle2FaSuccess(): void {
      this.twoFactorDialog = false;
      window.location.reload();
    }

  mounted() {

    if (!this.me.is_admin && this.hasLogPermission) {
        this.activeRoute = 'logs'; // Marca o botão visualmente
        if (this.$route.name !== 'logs') {
            this.$router.push({ name: 'logs' });
        }
      }
  }

    open2FaDialog(): void {
    this.twoFactorDialog = true;
  }

  closeDialogUser() {
    this.dialogUser = false;
  }

  handleMeUpdated(data: any): void {
    this.setMe({ ...this.me, ...data });
  }

  showAdminSection(): void {
    this.showAdminBtn = false;
    this.showAdminRoutes = true;
    if (!this.me.is_admin && this.hasLogPermission) {
      this.activeRoute = 'logs';
      this.navigateTo('logs');
      return;
    } else {
      this.activeRoute = 'users';
      this.navigateTo("users");
    }
  }

  navigateTo(pageName: any, e: any = null): void {
    if (pageName === 'logs' && !this.me.is_admin && !this.hasLogPermission) {
      this.$emit('snackbar', {
        message: 'Você não tem permissão para acessar os logs.',
        color: 'red'
      });
      return;
    }
    if (e && e.ctrlKey) {
      let rout: any = this.$router.options.routes?.find((r) => r.name == pageName);
      window.open(rout.path, "_blank");
      setTimeout(() => {
        this.syncHeaderRouteState();
      });
      return;
    }

    if (this.$route.name == pageName) return;
    this.$router.push({ name: pageName });
  }

  navigateHome(): void {
    if (this.$route.name == "my-apps") return;
    this.showAdminRoutes = false;
    this.showAdminBtn = true;
    this.$router.push({ name: "my-apps" });
  }

  logout(): void {
    if (this.$route.name == "login") return;
    logSendLogout().finally(() => {
      toLogin();
      setTimeout(() => {
        this.actionsSetMe({});
      }, 3000);
    });
  }
}
</script>

<style lang="scss" scoped>
.app-title,
.btn-routes {
  font-weight: 600;
  border-radius: 5px !important;
  height: 36px !important;
}
.app-name {
  color: inherit;
  text-decoration: none;
}
.file-user :hover {
  cursor: pointer;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  background-color: rgba(0, 0, 0, 0.3);
}
.overlay:hover {
  opacity: 1;
}
.mold {
  border-radius: 50px;
  padding: 2px 2px 2px 8px;
}
.mold.active {
  border: 1px solid rgb(255 152 0);
  background-color: rgba(255, 152, 0, 0.2);
}
.btn-home {
  &:hover {
    cursor: pointer;
  }
}
</style>
